import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import deepCopy from 'src/utils/deepCopy'
import MainMenuSetup from './MainMenuSetup'
import './MainMenu.css'

const RenderChildren = (props) => {
  const { list, listItemClick, location, ...rest } = props
  const { pathname } = location

  return list.map(item => (
    <div key={item.id} className={`menu-item${item.hide} ${pathname === item.path ? 'active' : ''}`} data-id={item.id} data-pid={item.pid} data-path={item.path} data-open={item.open}>
      {
        !item.path
        ? <ListItemButton onClick={(e) => listItemClick(e,item)} data-click="true">
            <ListItemText primary={item.title} />
            {item.open ? <ExpandLess style={{ minWidth: 24 }} /> : <ExpandMore />}
          </ListItemButton>
        : <Link to={item.path}>
            <ListItemButton>
              <ListItemText primary={item.title} />
            </ListItemButton>
          </Link>
      }
      { item.children ? <RenderChildren {...rest} list={item.children} listItemClick={listItemClick} location={props.location} /> : null }
    </div>
  ))
}


const MainMenu = (props) => {
  const historyLocation = useLocation()
  const [menus, setMenus] = useState([])
  useEffect(() => {
    dealListToTree()
    // eslint-disable-next-line
  }, [])

  //------------------------------------------------------
  // this method is change return data list to tree list
  // because tree list can render menu list fast and easy
  //------------------------------------------------------
  const dealListToTree = () => {
    const arr = []
    const list = deepCopy(MainMenuSetup)
    list.forEach(item1 => {
      if (!item1.path) {
        item1.open = !!item1.open
        item1.children = []
      }
      item1.hide = item1.hide || ' hide'
      list.forEach(item2 => {
        item2.pid === item1.id && item1.children && item1.children.push(item2)
      })
      !item1.pid && arr.push(item1)
    })
    setMenus(arr)
  }

  const listItemClick = (e, item) => {
    MainMenuSetup.forEach(item1 => {
      if (item1.id === item.id) {
        item1.open = !item1.open
      }
    })
    MainMenuSetup.forEach(item2 => {
      if (item2.pid && item2.pid === item.id) {
        item2.hide = item.open ? ' hide' : ' show'
      }
    })
    dealListToTree()
  }

  return (
    <div className="MainMenu">
      <RenderChildren {...props} list={menus} listItemClick={listItemClick} location={historyLocation} />
    </div>
  )
}

export default MainMenu
